<osn-cxb-dialog [title]="title">
  <ng-container *ngIf="phase === ConfigEditorConfirmationPhase.First">
    <div class="d-flex align-items-center p-4 warning">
      <svg-icon class="mr-4 icon-white" fontSize="110px" key="warning"></svg-icon>
      <div>
        <p class="text-title-l">{{ warningText }}</p>
        <p class="text-title-l mt-4">Do you want to continue?</p>
      </div>
    </div>
    <div class="action mt-4">
      <button class="action-btn secondary" data-testid="config-editor-update-delete-config-confirm-yes-btn" (click)="onSaveClick()">
        {{ actionText }}
      </button>
      <button class="action-btn" type="button" (click)="onCancelClick()">No, back to editing</button>
    </div>
  </ng-container>
  <ng-container *ngIf="phase === ConfigEditorConfirmationPhase.Second">
    <div class="d-flex flex-column">
      <p class="mb-2">Please confirm by typing in the config key</p>
      <mat-form-field>
        <input
          matInput
          data-testid="config-editor-delete-config-confirm-key-input"
          type="text"
          placeholder="Config key"
          autocomplete="off"
          [formControl]="keyCtrl"
        />
        <mat-error *ngIf="keyCtrl.touched && keyCtrl.hasError('required')">Confirmation is required</mat-error>
        <mat-error *ngIf="keyCtrl.touched && keyCtrl.hasError('pattern')">The provided key doesn't match with the config key</mat-error>
      </mat-form-field>
    </div>
    <div class="action mt-4">
      <button
        class="action-btn secondary"
        data-testid="config-editor-delete-config-confirm-yes-btn"
        [disabled]="keyCtrl.invalid"
        (click)="onConfirmClick()"
      >
        Confirm
      </button>
      <button class="action-btn" data-testid="config-editor-delete-config-confirm-no-btn" type="button" (click)="onConfirmCancelClick()">
        Cancel
      </button>
    </div>
  </ng-container>
</osn-cxb-dialog>
